import {Injectable} from '@angular/core';
import {Platform} from '@ionic/angular';
import {LocationService} from './location.service';

export interface IDesktopNotification {
  eventHash?: string;
  text: string;
  body: string;
  event?: string;
  locationId?: string;
  icon?: string;
  onClick?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class DesktopNotificationService {
  constructor(
    private platform: Platform,
    private locationService: LocationService
  ) {
    this.initNotifications();
  }

  initNotifications() {
    if (this.platform.is('mobile') || !window.Notification) {
      return;
    }

    this.checkPermission();
  }

  async checkPermission() {
    if (Notification.permission !== 'granted') {
      await Notification.requestPermission();
    }
  }

  public async showDesktopNotification(config: IDesktopNotification) {
    console.log('showDesktopNotification', config);

    if (typeof Notification === 'undefined') {
      return;
    }

    if (config.locationId && config.event) {
      const hasEvent = await this.locationService.checkLocationEventsSetting(config.locationId, config.event);

      if (!hasEvent) {
        console.log(`Location "${config.locationId}" has not enabled event "${config.event}" as notification for this user`);
        return;
      }
    }

    if (config.locationId && config.event) {
      const hasEvent = await this.locationService.checkLocationEventsSetting(config.locationId, config.event);

      if (!hasEvent) {
        console.log(`Location "${config.locationId}" has not enabled event "${config.event}" as notification for this user`);
        return;
      }
    }

    if (Notification?.permission === 'granted' && !document.hasFocus()) {
      const notification = new Notification(config.text, {
        tag: config.eventHash,
        body: config.body,
        icon: config.icon
      });

      if (config.onClick) {
        notification.onclick = function(event) {
          event.preventDefault(); // prevent the browser from focusing the Notification's tab
          config.onClick();
          window.focus();
          this.close();
        };
      }
    }
  }
}
